import PostOrder from '@/language/pt/components/post/PostOrder';

export default {
  PostOrder,
};
